import { render, staticRenderFns } from "./ImageSelector.vue?vue&type=template&id=53c4e6d0&"
import script from "./ImageSelector.vue?vue&type=script&lang=js&"
export * from "./ImageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports